interface Props {
  onlineTime: Date;
  clientTime: Date;
}

const clockIsSEt = ({ onlineTime, clientTime }: Props) => {
  const onlineTimeToString = String(new Date(onlineTime))?.split(":", 2).join();
  const clientTimeToString = String(new Date(clientTime))?.split(":", 2).join();

  return { isTimeAccurate: onlineTimeToString === clientTimeToString };
};

export default clockIsSEt;
